import type { FaireProductEntity } from "../../entity_types/product";

export const p_gf49gktt6z: FaireProductEntity = {
  token: "p_gf49gktt6z",
  type: "product",
  name: "Wayuu mochila Bag - Handwoven crochet Crossbody Shoulder bag",
  brandToken: "b_rz9qg9uuan",
  brandName: "",
  imageUrl:
    "https://cdn.faire.com/fastly/e2178b6f3f6ec8eea1f3f07676e68182f6e6925ccc40f8a667141b786ce8ffbd.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/369d064cea42be9695f2e4f54b50edea2ff082da3371ce8f442a3ea1046cbe87.png",
  ],
  priceDollars: 61.5,
  description:
    'Your ultimate summer accessory!\n\nThis beautiful and unique mochila bag is handwoven by Wayuu artisans from La Guajira, Colombia. It is an ancestral work of art made in a unique weaving technique with a magic needle and Wayuu thread. It is super versatile, which makes it the perfect accessory to be used out in the city or to spend a day at the beach. With its large crossbody strap, you will want to carry it around everywhere you go! \n\nMEDIUM\nHeight: 24-25 cm / 9.8"\nLength: 26cm / 10.2"\n\nLARGE\nHeight: 29-30cm / 11.8"\nLength: 36cm / 14.2"\n\nAll of our items are 100% handmade. Please allow for any color and sizing variations, or natural imperfections created during the hand making process.',
  tags: [],
  msrpDollars: 123,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-07T04:57:34.334Z",
    importedBy: "gen-brand-update-tile-products.mjs",
  },
  categoryTokens: [],
};
